// @ai-generated 2026-07-05T11:55:00Z by dimitri.driediger@synqony.com using Claude Fable 5
import { type ApiContactSnapshot } from '@Model';
import { isLinked } from '@synqo/frontend-component-library';

/** An empty snapshot (no link, no name) means no on-site contact was provided. */
export const hasSiteContact = (snapshot: ApiContactSnapshot): boolean =>
    isLinked(snapshot) || !!siteContactName(snapshot);

/**
 * Display name of the on-site contact. Prefers the server-computed display string and falls
 * back to the raw name parts for drafts the server has not saved yet.
 */
export const siteContactName = (snapshot: ApiContactSnapshot): string =>
    snapshot.display_string || `${snapshot.first_name} ${snapshot.last_name}`.trim();

/** Phone number to show next to the on-site contact; empty numbers yield undefined. */
export const siteContactDetail = (snapshot: ApiContactSnapshot): string | undefined =>
    snapshot.phone || snapshot.mobile || undefined;
